import React from 'react';
import { Outlet } from 'react-router-dom';
import { MobileNavbar } from './MobileNavbar';
import { MobileBottomNav } from './MobileBottomNav';

export function MobileLayout() {
  return (
    <div className="flex flex-col min-h-screen bg-[#111318]">
      <MobileNavbar />
      <main className="flex-1 pb-16">
        <Outlet />
      </main>
      <MobileBottomNav />
    </div>
  );
}